import { useQuery } from '@apollo/client';
import { GridContent, GridLayout, Heading, Page, PageContent, PageTitle } from '@zillow/constellation';
import { GetApplicationsForUserDocument } from '../graphql/queries';
import { ApplicationsList } from '../components/ApplicationsList';
import { FullWidthPropertyCard } from '../styles/styled-components';

export default function ApplicationsPage() {
  const { loading, data } = useQuery(GetApplicationsForUserDocument, {
    variables: {
      includeSharedApplications: true,
    },
  });

  return (
    <Page backgroundColor="backgroundLight">
      <PageTitle heading={<Heading level={1}>Your rental applications</Heading>}></PageTitle>
      <PageContent>
        <GridLayout>
          <GridContent gridColumnEnd="span 12">
            {data && <ApplicationsList data={data} />}
            {loading && !data && <ApplicationsLoading />}
          </GridContent>
        </GridLayout>
      </PageContent>
    </Page>
  );
}

function ApplicationsLoading() {
  return (
    <>
      <FullWidthPropertyCard appearance="horizontal" data={{}} loading marginBottom="sm" />
      <FullWidthPropertyCard appearance="horizontal" data={{}} loading marginBottom="sm" />
      <FullWidthPropertyCard appearance="horizontal" data={{}} loading marginBottom="sm" />
    </>
  );
}
